import { createSlice } from "@reduxjs/toolkit";

const detallespagosState = {
  datadetallespagos: {},
}

export const detallespagosSlice = createSlice({
  name: "detallespagos",
  initialState: detallespagosState,
  reducers: {
    StoreDetallePagosData: (state, actions) => {
      state.datadetallespagos = actions.payload;
    },
    ResetDetallePagosData: () => detallespagosState,
  }
});

export const { StoreDetallePagosData, ResetDetallePagosData } = detallespagosSlice.actions;

export default detallespagosSlice.reducer;